import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    this.onDocumentClick = this.handleDocumentClick.bind(this)
    this.onDocumentKeydown = this.handleDocumentKeydown.bind(this)
    document.addEventListener("click", this.onDocumentClick)
    document.addEventListener("keydown", this.onDocumentKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
    document.removeEventListener("keydown", this.onDocumentKeydown)
  }

  toggle(event) {
    event.preventDefault()
    this.menuTarget.hidden = !this.menuTarget.hidden
    this.buttonTarget.setAttribute("aria-expanded", (!this.menuTarget.hidden).toString())
  }

  close() {
    this.menuTarget.hidden = true
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }

  handleDocumentClick(event) {
    if (this.element.contains(event.target)) return
    this.close()
  }

  handleDocumentKeydown(event) {
    if (event.key !== "Escape") return
    this.close()
  }
}
